document.addEventListener("mouseover", function (e) {
  var wrapper = e.target.closest(".card-wrapper");
  if (!wrapper) return;
  var video = wrapper.querySelector("video.card-video-hover");
  if (!video) return;
  video.play();
});
document.addEventListener("mouseout", function (e) {
  var wrapper = e.target.closest(".card-wrapper");
  if (!wrapper) return;
  if (wrapper.contains(e.relatedTarget)) return;
  var video = wrapper.querySelector("video.card-video-hover");
  if (!video) return;
  video.pause();
});
